import { generalConst } from './globalInterface'

export const LOGIN_CLIENT_ID = '10b56c3e-5e00-4bbc-b2c7-d9e0251c749a'

export const DEFAULT_LOCALE: String = 'en'

export const ROUTES: generalConst = {
  BASE: '',
  LOGIN: '/login',
  WELCOME: '/welcome',
  REQUESTHISTORY: '/request-history',
  APPROVALS: '/approvals',
  TASKS: '/tasks',
  ABILITATIONREQUEST: '/entitlement-request',
  CATALOG: '/catalog',
  DELEGATES: '/delegates',
  ENTITLEMENT_REFERENCE: '/entitlementReference',
  USER_ENTITLEMENT: '/userEntitlement',
  USERSREFERENCE: '/users-reference',
  EMERGENCY_USERS: '/emergency-users',
  BR_MANAGEMENT: '/business-roles-management',
  PROFILE_MGMT: '/profile-management',
  RESET_PASSWORD: '/reset-password',
  CHANGE_PASSWORD: '/change-password',
  CERTIFICATION_REFERENCE: '/certification-reference',
  CREATE_CERTIFICATION: '/create-certification',
  SERVICE_REQUEST: '/service-request',
  MANUALS: '/manuals-reference',
  FORBIDDEN: '/not-found',
  REPORT: '/report',
  TEMPORARY_ABILITATIONS: '/temporary-abilitations',
  TECHNICAL_USERS: '/technical-users',
  CONSOLE_ADMIN: '/admin',
  ADMIN_USERS_MGMT: '/admin-users-management',
  ADMIN_APPLICATIONS_ABILITATIONS_MGMT:
    '/admin-applications-abilitations-management',
  ADMIN_BR_MGMT: '/admin-business-role-management',
  ADMIN_CATALOG_MGMT: '/admin-catalog-management',
  ADMIN_PWD_MGMT: '/admin-password-management',
  ADMIN_EXTERNAL_PORTAL_MGMT: '/admin-external-portal-management',
  ADMIN_SOD_MGMT: '/admin-sod-management',
  ADMIN_SERVICE_REQUEST_MGMT: '/admin-service-request-management',
  ADMIN_MANUALS_MGMT: '/admin-manuals-management',
  ADMIN_REPORT_MGMT: '/admin-report-management',
  ADMIN_TEMPLATE_MAIL_MGMT: '/admin-template-mail-management',
  ADMIN_TEMPLATE_SMS_MGMT: '/admin-template-sms-management',
  ADMIN_WORKFLOW_MGMT: '/admin-workflow-management',
  ADMIN_TABLES_CONFIGURATION_MGMT: '/admin-tables-configuration-management',
  ADMIN_RECOVERY_POINT_MGMT: '/admin-recovery-point-management',
  ADMIN_PROFILES_MGMT: '/admin-profiles-management',
  ADMIN_CREATE_CERTIFICATION: '/admin-create-certification',
  ADMIN_CERTIFICATION_CONFIGURATIONS_MGMT:
    '/admin-certification-configurations-management',
  ADMIN_AUDIT_MGMT: '/admin-audit-management',
  ADMIN_NOTIFY_MGMT: '/admin-notify-management',
  ADMIN_TEMPORARY_ABILITATIONS_MGMT: '/admin-temporary-abilitations-management',
  ADMIN_UIGP_MGMT: '/admin-uigp-management',
  ADMIN_CSV_UPLOADER: '/admin-csv-uploader',
  ADMIN_TECHNICAL_USERS_MGMT: '/admin-technical-users-management',
  EXTERNAL_PORTAL: '/external-portal',
}

export const DATE_FORMAT = {
  YYYYMMDD: 'YYYY MM DD',
}

export const DAY_TIME_STAMP_VALUE: number = 86400000

export const JSON_CONTENT_TYPE = 'application/json'
export const FILE_CONTENT_TYPE = 'application/octet-stream'
export const FILE_ACCEPT_TYPE =
  'text/html,application/xhtml+xml,application/xml;q=0.9,image/avif,image/webp,*/*;q=0.8'
export const RESPONSE_TYPE = {
  BLOB: 'blob',
  JSON: 'json',
  OCTET_STREAM: 'application/octet-stream',
  BASE_64: 'text/plain',
  TEXT_PLAIN: 'text/plain;charset=UTF-8',
}

export enum OtpOperationType {
  FORGOTTEN_PWD = 'FORGOTTEN_PWD',
  RESET_PWD = 'RESET_PWD',
  CHANGE_PWD = 'CHANGE_PWD',
  CHANGE_MOBILE = 'CHANGE_MOBILE',
}

export const IDENTITY_SYSTEM = {
  '1': 'ITA',
  '2': 'NOR',
}

export enum IdentitySystemType {
  ITA = 1,
  NOR = 2,
}

export const IDENTITY_SYSTEM_LIST = [
  {
    label: 'ITA',
    value: 1,
  },
  {
    label: 'NOR',
    value: 2,
  },
]

export const UIGP_CHANNEL_SECURITY_HEADER = 'UIGP_CHANNEL_SECURITY_HEADER'
export const INTERNET = 'INTERNET'
